import { generateUrlByQuery } from "@stadium/helpers/dom";

import {
  RECOGNITION_PROGRAM_SETTINGS_TAB,
  RECOGNITION_PROGRAM_SETTINGS_TAB_WITH_CHILD_TAB,
} from "@constants/routes";

export const SETTINGS_TAB_KEYS = {
  general: "general",
  users: "users",
  hashtags: "hashtags",
  integrations: "integrations",
  redemptionShop: "redemption-shop",
  billing: "billing",
  deleteProgram: "delete-program",
} as const;

export const { general, users, hashtags, integrations, billing, deleteProgram, redemptionShop } =
  SETTINGS_TAB_KEYS;

export const INTEGRATION_CHILD_TAB_KEYS = {
  slackSettings: "slackSettings",
  msTeamsSettings: "msTeamsSettings",
} as const;

export const { slackSettings, msTeamsSettings } = INTEGRATION_CHILD_TAB_KEYS;

export type TYPE_SETTINGS_TABS =
  | "general"
  | "users"
  | "hashtags"
  | "integrations"
  | "billing"
  | "delete-program"
  | "redemption-shop";

export type INTEGRATION_CHILD_TABS = "slackSettings" | "msTeamsSettings";

export const SETTINGS_TAB_ORDER = [
  general,
  users,
  hashtags,
  redemptionShop,
  integrations,
  billing,
  deleteProgram,
] as const;

const getProgramSettingTabRoute = (number: string, tab: TYPE_SETTINGS_TABS) =>
  generateUrlByQuery({
    query: {
      tab,
      number,
    },
    pathname: RECOGNITION_PROGRAM_SETTINGS_TAB,
  });

export const getProgramIntegrationSettingsChildRoute = (
  number: string,
  childTab: INTEGRATION_CHILD_TABS,
) =>
  generateUrlByQuery({
    query: {
      tab: integrations,
      number,
      childTab,
    },
    pathname: RECOGNITION_PROGRAM_SETTINGS_TAB_WITH_CHILD_TAB,
  });

export const SETTINGS_TABS = {
  [general]: {
    id: general,
    label: "General",
    route: (id: string) => getProgramSettingTabRoute(id, general),
    show: () => true,
  },
  [users]: {
    id: users,
    label: "Users",
    route: (id: string) => getProgramSettingTabRoute(id, users),
    show: () => true,
  },
  [hashtags]: {
    id: hashtags,
    label: "Hashtags",
    route: (id: string) => getProgramSettingTabRoute(id, hashtags),
    show: () => true,
  },
  [redemptionShop]: {
    id: redemptionShop,
    label: "Redemption Shop",
    route: (id: string) => getProgramSettingTabRoute(id, redemptionShop),
    show: ({ attachMonetaryValue }) => attachMonetaryValue,
  },
  [integrations]: {
    id: integrations,
    label: "Integrations",
    route: (id: string) => getProgramSettingTabRoute(id, integrations),
    show: () => true,
  },
  [deleteProgram]: {
    id: deleteProgram,
    label: "Delete program",
    route: (id: string) => getProgramSettingTabRoute(id, deleteProgram),
    show: () => true,
  },
  [billing]: {
    id: billing,
    label: "Billing",
    route: (id: string) => getProgramSettingTabRoute(id, billing),
    show: ({ attachMonetaryValue }) => attachMonetaryValue,
  },
} as const;
